// extracted by mini-css-extract-plugin
export var courseButton = "course-post-module--courseButton--8096a";
export var courseColumnListRtl = "course-post-module--courseColumnListRtl--3e5d1";
export var ctaContainer = "course-post-module--ctaContainer--46077";
export var pageComponents = "course-post-module--pageComponents--2430e";